import type { GetProductsUsageReportResponsePayload } from '@vy/api-definition';
import { GetProductsUsageReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined, withDefault } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useProductsUsageReport(
  reportId?: string,
  options?: CustomUseQueryOptions<GetProductsUsageReportResponsePayload>,
) {
  const reportIdentifier = withDefault(reportId, '');
  const getProductsUsageReportQuery = useQuery(
    queryKeys.productsUsageReport(reportIdentifier),
    async () => {
      const api = getPrivateApi();
      const getProductsUsageReportResponse = await api.getProductsUsageReport({
        reportId,
      });

      return GetProductsUsageReportResponseSchema.parse(getProductsUsageReportResponse);
    },
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(getProductsUsageReportQuery.data, 'getProductsUsageReportQuery data');

  return getProductsUsageReportQuery;
}
